import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import React from 'react';
import { STATES } from '../../constants.ts';
interface User {
  user_id: string;
  full_name: string;
  email: string;
  phone: string;
  password: string;
  is_admin: boolean;
  last_login: string;
  states: string[]; // stores state CODES (e.g., 'NC')
  custom_message?: string;
}
const EditUserModal = ({ 
  closeEdit, 
  editOpen, 
  editUser, 
  setEditUser, 
  requestSave 
}: { editUser: User | null; closeEdit: () => void; setEditUser: (user: User) => void; requestSave: () => void; editOpen: boolean }) => {
  return (
    <Dialog open={editOpen} onClose={closeEdit} maxWidth="sm" fullWidth>
      <DialogTitle>Edit User</DialogTitle>
      <DialogContent dividers>
        {editUser && (
          <Box display="flex" flexDirection="column" gap={2} mt={1}>
            <TextField
              label="Full Name"
              value={editUser.full_name}
              onChange={(e) => setEditUser({ ...editUser, full_name: e.target.value })}
              fullWidth
            />
            <TextField
              label="Email"
              type="email"
              value={editUser.email}
              onChange={(e) => setEditUser({ ...editUser, email: e.target.value })}
              fullWidth
            />
            <TextField
              label="Phone"
              type="tel"
              value={editUser.phone}
              onChange={(e) => setEditUser({ ...editUser, phone: e.target.value })}
              fullWidth
            />
            <TextField
              label="Password"
              type="password"
              value={editUser.password}
              onChange={(e) => setEditUser({ ...editUser, password: e.target.value })}
              fullWidth
            />
            <FormControl fullWidth>
              <InputLabel>User Role</InputLabel>
              <Select
                value={editUser.is_admin ? 'Admin' : 'User'}
                onChange={(e) => setEditUser({ ...editUser, is_admin: e.target.value === 'Admin' })}
                label="User Role"
              >
                <MenuItem value="User">User</MenuItem>
                <MenuItem value="Admin">Admin</MenuItem>
              </Select>
            </FormControl>
            <FormControl fullWidth>
              <InputLabel>States</InputLabel>
              <Select
                multiple
                value={editUser.states}
                onChange={(e) => setEditUser({ ...editUser, states: e.target.value as string[] })}
                label="States"
              >
                {STATES.map(({ code, name }) => (
                  <MenuItem key={code} value={code}>
                    {name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              label="Custom Message"
              value={editUser.custom_message || ''}
              onChange={(e) => setEditUser({ ...editUser, custom_message: e.target.value })}
              fullWidth
              multiline
              minRows={2}
            />
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={closeEdit}>Cancel</Button>
        <Button variant="contained" onClick={requestSave}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default EditUserModal;